import { QueryClient } from '@tanstack/react-query';
import { CaseFilters } from 'queries/cases/queries';
import { CaseListItem } from 'queries/cases/types';

export function hiddenNewFlag({
  caseItem,
  queryClient,
  queryFilters,
}: {
  caseItem?: CaseListItem;
  queryClient: QueryClient;
  queryFilters: CaseFilters;
}) {
  if (caseItem) {
    queryClient.setQueryData<{ cases: CaseListItem[] }>(
      ['GET_CASES', 'MONITORING_LOADING', queryFilters],
      (prevCases) => ({
        cases:
          prevCases?.cases.map((item) =>
            item.id === caseItem.id
              ? {
                  ...item,
                  alarms_30_days: {
                    quantity: item.alarms_30_days?.quantity ?? 0,
                    has_new: false,
                  },
                }
              : item,
          ) ?? [],
      }),
    );
  }
}
